var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDextools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61646 4.14633L14.9659 0.436523L22.6321 4.3587L17.3671 6.7257L14.9821 5.46573L12.579 6.7257L7.61646 4.14633Z",
    fill: "#52B4D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61646 29.5501L14.9659 33.2599L22.6321 29.3377L17.3671 26.9707L14.9821 28.2307L12.579 26.9707L7.61646 29.5501Z",
    fill: "#52B4D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.443359 7.75195V16.9554L4.89474 15.0294V10.0379L0.443359 7.75195Z",
    fill: "#52B4D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79027 5.55957L0.445068 7.75019L9.94907 12.837L14.7893 10.6464L4.79027 5.55957Z",
    fill: "#52B4D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2312 28.2071L29.5511 26.0165L20.0939 20.9297L15.2771 23.1203L25.2312 28.2071Z",
    fill: "#52B4D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0691 18.8075C25.1753 18.8075 29.5566 16.9355 29.5566 16.9355V26.0723L25.2816 28.1712L25.0691 18.8075Z",
    fill: "#52B4D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.443359 20.6814L26.4516 9.19922L29.5548 13.1395L4.18915 24.3877L0.443359 20.6814Z",
    fill: "#52B4D7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4414 8.20865L29.5565 13.1389V7.74964L25.6344 5.80566L20.4414 8.20865Z",
    fill: "#52B4D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59273 25.6636L0.477539 20.7334V26.1226L4.39971 28.0666L9.59273 25.6636Z",
    fill: "#52B4D7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDextools);
export default __webpack_public_path__ + "static/media/dextools.08616680140d87869b367d09e5c59334.svg";
export { ForwardRef as ReactComponent };